import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../material.module';
import { TranslatePipe } from '../../../pipes/translate.pipe';

export type ConfirmDialogVariant = 'warning' | 'info' | 'danger';

export interface ConfirmDialogData {
  title: string;
  message: string;
  question?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmColor?: 'primary' | 'warn' | 'accent';
  icon?: string;
  variant?: ConfirmDialogVariant;
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MaterialModule, MatDialogModule, TranslatePipe],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  get variant(): ConfirmDialogVariant {
    return this.data.variant ?? 'warning';
  }

  get confirmColor(): 'primary' | 'warn' | 'accent' {
    return this.data.confirmColor ?? 'primary';
  }

  get icon(): string {
    if (this.data.icon) {
      return this.data.icon;
    }

    switch (this.variant) {
      case 'danger':
        return 'error_outline';
      case 'info':
        return 'info';
      default:
        return 'warning_amber';
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
